import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OutlookSkeletonLineComponent } from './skeleton-line.component';

@Component({
    selector: 'maximizer-outlook-skeleton-entry',
    template: `
    <div class="w-full flex gap-2">
      <maximizer-outlook-skeleton
        containerClasses="h-9 w-9 max-w-9 rounded-full bg-neutral-20"
        fullWidth="none"
      ></maximizer-outlook-skeleton>
      <maximizer-outlook-skeleton
        containerClasses="h-9 w-full rounded-md bg-neutral-20"
      ></maximizer-outlook-skeleton>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [OutlookSkeletonLineComponent],
})
export class OutlookSkeletonEntryComponent {}
